// https://newbedev.com/javascript-how-to-dynamically-create-nested-objects-using-object-names-given-by-an-array

/**
 *
 * @param {Object} base - Base object to create nested object from
 * @param {string} path - Dot notation string such as 'aaa.bbb.ccc' which is turned into nested objects on 'base'
 * @param {*} val - Default value which base.path will be set to.
 * @description This method will create a nested object on 'base' by creating objects from the dot notation string in 'path'.
 * @example
 * // base = window
 * // path = 'aaa.bbb.ccc'
 * // val = 'ddd'
 * // window:
 * {
 * 		aaa: {
 * 			bbb: {
 * 				ccc: 'ddd'
 * 			}
 * 		}
 * }
 */
const createNestedObject = (base, path, val) => {
	const keys = path.split('.');
	const lastKey = keys.pop();
	const lastObj = keys.reduce((obj, key) => {
		// intentional as we do want to modify the previous value
		// eslint-disable-next-line no-param-reassign
		obj[key] = obj[key] || {};
		return obj[key];
	}, base);
	lastObj[lastKey] = val;
};

export default createNestedObject;
